<input type="button" (click)="openEditPhoto()" />
